module.exports = __webpack_public_path__ + "static/img/Visualization5.2c1507f5.png";